import request from '@/utils/request'

// 新增联系我们咨询记录
export function addWebsite(data) {
  return request({
    url: '/website/website',
    method: 'post',
    withToken: false,
    data: data
  })
}

// 修改联系我们咨询记录
export function updateWebsite(data) {
  return request({
    url: '/website/website',
    method: 'put',
    data: data
  })
}
